module.exports = __webpack_public_path__ + "static/img/HQSH.499c166.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HQSH.svg
// module id = vJRH
// module chunks = 1